/* btg-motion.js — By The Gaze
   Original motion utilities for the BTG theme. No external dependencies.
     [data-reveal]  masked word-by-word reveal — words rise into view, staggered in groups
     [data-speed]   scroll-linked parallax drift (1 = static, >1 drifts faster)
   Honours prefers-reduced-motion and re-inits inside the Shopify theme editor. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Word reveal ---------- */
  var REVEAL_DURATION = '1.35s';
  var REVEAL_EASING = 'cubic-bezier(0.19, 1, 0.22, 1)';
  var WORDS_PER_STEP = 6; // words that share one stagger group
  var STEP = 0.13; // seconds added per group

  function splitWords(el) {
    if (el.dataset.revealReady === 'true') return;
    var words = el.textContent.replace(/\s+/g, ' ').trim().split(' ');
    el.textContent = '';
    el.classList.add('btg-reveal');
    words.forEach(function (word, i) {
      var mask = document.createElement('span');
      mask.className = 'btg-reveal__word';
      var inner = document.createElement('span');
      inner.className = 'btg-reveal__inner';
      inner.textContent = word;
      if (!reduceMotion) {
        var delay = Math.floor(i / WORDS_PER_STEP) * STEP;
        inner.style.transition = 'transform ' + REVEAL_DURATION + ' ' + REVEAL_EASING + ' ' + delay + 's';
      }
      mask.appendChild(inner);
      el.appendChild(mask);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el.dataset.revealReady = 'true';
  }

  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (!els.length) return;
    els.forEach(splitWords);
    if (reduceMotion) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' },
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- Parallax ---------- */
  var PARALLAX_INTENSITY = 0.6; // global tuning multiplier for drift distance

  function initParallax() {
    if (reduceMotion) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-speed]'));
    if (!els.length) return;

    var items = els.map(function (el) {
      return { el: el, speed: parseFloat(el.getAttribute('data-speed')) || 1, current: 0, target: 0 };
    });
    var ticking = false;

    function compute() {
      var vh = window.innerHeight;
      items.forEach(function (it) {
        var rect = it.el.getBoundingClientRect();
        var distance = rect.top + rect.height / 2 - vh / 2; // +ve when below viewport centre
        it.target = -distance * (it.speed - 1) * PARALLAX_INTENSITY;
      });
    }

    function render() {
      var settled = true;
      items.forEach(function (it) {
        it.current += (it.target - it.current) * 0.1; // lerp for smoothness
        if (Math.abs(it.target - it.current) > 0.1) settled = false;
        it.el.style.transform = 'translate3d(0,' + it.current.toFixed(2) + 'px,0)';
      });
      if (!settled) requestAnimationFrame(render);
      else ticking = false;
    }

    function onScroll() {
      compute();
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(render);
      }
    }

    compute();
    items.forEach(function (it) {
      it.current = it.target;
    });
    render();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  function init() {
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
